/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useOrdersApi } from '../../../../apis';
import { FILE_DOWNLOAD_FORMATS } from '../../../../apis/constants/fileDownloadFormats';
import { downloadFileFromApi } from '../../../../apis/Utilities/downloadFileFromApi';
import { FileExportSelector } from '../../../FileExportSelector';
import { getTrueKeysAsCSV } from '../../../../utils/projections';
import { toDateRangeFilter } from '../../../../utils/dateRangeFilter';
import { cleanObject } from '../../../../utils/objectExtensions';

function DataExport(props) {
	const {
		filters,
		dataTestId,
		columnOrder,
		columnVisibility,
		sort,
		isLoading,
	} = props;

	const { t } = useTranslation('common');
	const { pathname } = useLocation();
	const { searchKey } = useParams();
	const { downloadOrderList } = useOrdersApi();

	const options = useMemo(
		() => [
			{ key: FILE_DOWNLOAD_FORMATS.CSV, value: 'CSV' },
			{ key: FILE_DOWNLOAD_FORMATS.EXCEL, value: 'Excel' },
		],
		[]
	);

	const generateOrderFilters = () =>
		cleanObject({
			Ship_To_Number: filters?.shipToLocation || undefined,
			Plant_Code: filters?.siteLocation || undefined,
			Order_Date: toDateRangeFilter(filters?.orderDate),
			Order_Due_Date: toDateRangeFilter(filters?.dueDate),
		});

	const handleDownload = async (format) => {
		const columnNames = columnOrder
			.filter((k) => columnVisibility[k])
			.filter((k) => k !== 'DigitalDocuments');

		const isSearchPage = pathname.includes('search');

		// Searching is mutually exclusive from filters and status filtering
		const ordersFiltersClass = {
			Order_By: sort || 'Order_Date DESC',
			Status: isSearchPage
				? undefined
				: getTrueKeysAsCSV(filters?.status) || undefined,
			Search: isSearchPage ? searchKey : undefined,
			Filters: isSearchPage ? undefined : generateOrderFilters(),
		};

		const payload = {
			columnNames,
			filters: ordersFiltersClass,
		};

		await downloadFileFromApi({
			format,
			defaultFilenamePrefix: 'MyOrders',
			executeApiCall: () => downloadOrderList({ format }, payload),
		});
	};

	return (
		<FileExportSelector
			options={options}
			onDownload={handleDownload}
			label={t('export')}
			isLoading={isLoading}
			dataTestId={dataTestId}
		/>
	);
}

DataExport.propTypes = {
	filters: PropTypes.object,
	sort: PropTypes.string.isRequired,
	dataTestId: PropTypes.string,
	columnOrder: PropTypes.array.isRequired,
	columnVisibility: PropTypes.object,
	isLoading: PropTypes.bool.isRequired,
};

export default DataExport;
